import Vue from 'vue'
import configs from '@/config'

const { publicDocumentSystemApiUrl } = configs

// AHA-47757: PPTX deck → editable content-v2 slides, via the DOCUMENT SYSTEM
// service — the same backend the modal's upload and the image import already
// talk to (see documentSystem.js), which is where the converter runs (it
// needs the file records, CloudConvert renders and job rows that live
// there). Job creation validates the deck before answering, so it gets the
// same headroom as the other conversion calls.
const docsys = `${publicDocumentSystemApiUrl}/api/docsys/ahaslides/api`

export const PPTX_CONVERT_TIMEOUT_MS = 45000
export const hasPptxConvertApi = Boolean(publicDocumentSystemApiUrl)

let resource = null

export const actions = {
  createConvertJob: {
    method: 'POST',
    url: `${docsys}/content/convert-pptx`,
    timeout: PPTX_CONVERT_TIMEOUT_MS,
  },
  getConvertJobStatus: {
    method: 'GET',
    url: `${docsys}/content/convert-pptx/{jobId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

/**
 * Start an async conversion job. The backend resolves `file_hash_id` (the
 * document-system upload the import modal already made) to a signed S3 URL
 * server-side — the browser never supplies a download URL. Resolves with
 * `{ job_id, slide_count }` (HTTP 202). A 409 means an import is already
 * running for this presentation (`body.detail.code = 'ImportAlreadyRunning'`).
 */
const createConvertJob = async ({ presentationId, fileHashId }) => {
  const res = await resource.createConvertJob({}, {
    presentation_id: String(presentationId),
    file_hash_id: fileHashId,
  })
  return res.body
}

/**
 * Poll a conversion job. Resolves with `{ status, slides, deck_warnings,
 * error }` where `status` is queued | running | done | failed and each
 * `slides[i]` is `{ index, status, new_slide_id, warnings }` with per-slide
 * status pending | converting | created | failed | skipped.
 */
const getConvertJobStatus = async (jobId) => {
  const res = await resource.getConvertJobStatus({ jobId })
  return res.body
}

export default {
  initResource,
  createConvertJob,
  getConvertJobStatus,
}
